import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface MetricCardProps {
    icon: LucideIcon;
    value: number | string;
    label: string;
    iconColor?: string;
    iconBgColor?: string;
}

export function MetricCard({
    icon: Icon,
    value,
    label,
    iconColor = "text-action-primary",
    iconBgColor = "bg-action-primary/10"
}: MetricCardProps) {
    return (
        <Card className="transition-shadow duration-200 hover:shadow-md">
            <CardContent className="p-6">
                <div className="flex flex-col space-y-3">
                    {/* Icon */}
                    <div className={`${iconBgColor} w-12 h-12 rounded-lg flex items-center justify-center`}>
                        <Icon className={`${iconColor} w-6 h-6`} />
                    </div>

                    {/* Value */}
                    <div className="text-3xl font-bold text-foreground tabular-nums">
                        {value.toLocaleString()}
                    </div>

                    {/* Label */}
                    <div className="text-sm text-muted-foreground font-medium">
                        {label}
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
